/* unplugin-vue-components disabled */import { render } from "./GeneralOverlay.vue?vue&type=template&id=b9bdf520&ts=true"
import script from "./GeneralOverlay.vue?vue&type=script&lang=ts"
export * from "./GeneralOverlay.vue?vue&type=script&lang=ts"

import "./GeneralOverlay.vue?vue&type=style&index=0&id=b9bdf520&lang=scss"

import exportComponent from "/root/workspace/estate-mobile_9SbA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__